import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})

export class ListFilterPipe implements PipeTransform {
    transform(items: any[], field1: string, field2: string , value: string): any[] {
        console.log(field1,field2,value);
          if (!items) {
              return [];
          }
          if (!field1 || !value) {
              return items;
          }
          if (field2) {
            return items.filter(singleItem => singleItem[field1][field2].toLowerCase().includes(value.toLowerCase()));
          } else {
            return items.filter(singleItem => singleItem[field1].toLowerCase().includes(value.toLowerCase()));
          }
           
      }
  }
